import type { Form, Stored, User } from "@overmap-ai/common"

import { CreatedByFilterDef } from "../defs/CreatedByFilterDef"
import { SubmittedAtFilterDef } from "../defs/SubmittedAtFilterDef"
import { FilterSchema } from "./FilterSchema"
import { createFilterDefConfig } from "./utils"

interface FormFilterSchemaConfig {
	users: User[]
}

export const getFormFilterSchema = (config: FormFilterSchemaConfig) => {
	const { users } = config

	return FilterSchema.create<Stored<Form>>({
		filterDefs: [
			createFilterDefConfig({
				filterDef: new CreatedByFilterDef(users),
				accessorFn: (submission) => submission.created_by ?? -1,
			}),
			createFilterDefConfig({
				filterDef: new SubmittedAtFilterDef(),
				accessorFn: (submission) => new Date(submission.submitted_at),
			}),
		],
	})
}
